import "./Fridge.css"
import Product1 from "./Product1"
import Fridge1 from "../images/fd1.jpg"
import Fridge2 from "../images/fd2.jpg"
import Fridge3 from "../images/fd3.jpg"
import Fridge4 from "../images/fd4.jpg"
import Fridge5 from "../images/fd5.jpg"
import Fridge6 from "../images/fd6.jpg"
import Fridge7 from "../images/fd7.jpg"
import Fridge8 from "../images/fd8.jpg"
import Fridge9 from "../images/fridgeadd.jpg"



export default function Fridge() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Fridge9} /></div>
          
                   

      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="fri1"  prdName="LG" img={Fridge1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="fri2"   prdName="HAIER" img={Fridge2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="fri3"  prdName="BLUESTAR" img={Fridge3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="fri4"  prdName="SAMSUNG" img={Fridge4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="fri5"  prdName="ONIDA" img={Fridge5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="fri6"  prdName="HAIER3" img={Fridge6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="fri7"  prdName="BLUSTAR" img={Fridge7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="fri8" prdName="WHIRLPOOL" img={Fridge8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}